export enum G4sPlacement {
    EXPLORE_WITH_AI_PAGE = "explore-with-ai-page",
    SIDE_PANEL = "ihub-side-panel",
}
